<script>

    import { createEventDispatcher } from 'svelte'
    import { toast } from 'bulma-toast'
    import { CreditStore, CreditsStore } from '../stores'

    import CreditsService from '../$services/credits.service'

    import Select from '../$components/select.svelte'
    import Form from '../$components/form.svelte'

    const dispatch = createEventDispatcher()

    let loading = false
    let data = {}

    async function createInvoice() {

        data.creditId = $CreditStore._id

        loading = true
        const resp = await CreditsService.createInvoice(data)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        CreditStore.set(resp.data)
        CreditsStore.replace(resp.data)

        toast({message: 'Factura creada', type: 'is-success'})
        dispatch('created', resp.data)
    }

</script>

<Form on:submit={ createInvoice } on:canceled { loading } >
    <div class="columns">
        <div class="column">
            <Select bind:value={ data.cfdiUse } 
                label="Uso del CFDI"
                icon="list-alt"
                options={[
                    {value: 'P01', text: 'Por definir'},
                    {value: 'G03', text: 'Gastos en general'},
                ]}
            />
        </div>
    </div>
    <Select bind:value={ data.paymentType } 
        label="Método de pago"
        icon="list-alt"
        options={[
            {value: '99', text: 'Por definir'},
            {value: '04', text: 'Tarjeta de crédito'},
            {value: '28', text: 'Tarjeta de débito'},
            {value: '01', text: 'Efectivo'},
            {value: '02', text: 'Cheque nominativo'},
            {value: '03', text: 'Transferencia electrónica de fondos'}
        ]}
    />
</Form>